
import React, { FC, createContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import { IonPage, IonContent, useIonViewDidEnter } from '@ionic/react'
import { deliveryMobx, memberMobx, storeMobx } from '@mobxStore'
import { restaurantCenter, mallMobx } from '@mobx/mall'
import { MallController, MallScrollController } from '@ctrls/mallController'
import { useHistoryNew, setDocumentTitle } from '@utils'
import { MallTop, ProductTemplate } from './components'
import mallChangeController from '@ctrls/mallChangeController'
import { useMallRepositoryInit } from '@common/hooks'
import './index.scss'

export const prodRecommendContent = createContext(null)

// interface
interface IProps extends IPage {
}

const Menu: FC<IProps> = ({ pageName }) => {
  const history = useHistoryNew()
  const showEditAddress = async () => {
    if (!deliveryMobx.hasAddresses) {
      await memberMobx.getMemberAddress()
      deliveryMobx.viewAddressesAll.length && deliveryMobx.setAddress(deliveryMobx.viewAddressesAll[0], 'mall')
    } else {
      deliveryMobx.viewAddressesAll.length && deliveryMobx.setAddress(deliveryMobx.viewAddressesAll[0], 'mall')
    }
  }
  // 处理首页滚动
  const handleHomeOnScroll = function (e: any) {
    const scrollTop = typeof e === 'number' ? e : (e.detail?.scrollTop || 0)
    if (scrollTop < 0) {
      return false
    }
    MallScrollController.handScroll(scrollTop, '#MallWarp')
  }
  useMallRepositoryInit()
  useIonViewDidEnter(() => {
    setDocumentTitle(storeMobx.brand?.brandName || i18n.t('pageName.mall'))
    showEditAddress()
    if (!mallMobx.isInited) {
      restaurantCenter.init()
    }
    MallScrollController.reset()
    MallController.restoreCartFromStorage()
    mallChangeController.menuSwitchEatType('mall')
  })
  return (
    <IonPage className='mall' title={pageName}>
      <IonContent
        className='mall-container'
        scrollEvents
        onIonScrollStart={() => (MallScrollController.isScrolling = true)}
        onIonScrollEnd={(e) => {
          MallScrollController.isScrolling = false
          const menuMeasureHeightDom = document.querySelector('.mall-content-container') as HTMLElement
          if (menuMeasureHeightDom) {
            const clientRects = menuMeasureHeightDom.getClientRects()
            if (clientRects && clientRects.length) {
              handleHomeOnScroll(Math.abs(clientRects[0].top))
            }
          }
        }}
        onIonScroll={(e) => { handleHomeOnScroll(e) }}
      >
        <div className='mall-content-container' id='MallWarp'>
          <MallTop />
          <ProductTemplate />
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(Menu)
